const getBrowserHeight = () => {
  const doc = document.documentElement;

  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};

export default getBrowserHeight;
